(() => {
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => [...root.querySelectorAll(s)];
  const focusable = 'a[href],button:not([disabled]),textarea,input,select,[tabindex]:not([tabindex="-1"])';
  document.documentElement.classList.remove('no-js');

  const header = qs('[data-header]');
  const setHeader = () => {
    if(!header) return;
    const scrolled = window.scrollY > 24;
    header.classList.toggle('is-scrolled', scrolled);
    header.dataset.scrolled = scrolled ? 'true' : 'false';
  };
  setHeader();
  window.addEventListener('scroll', setHeader, { passive: true });
  window.addEventListener('pageshow', setHeader);
  document.addEventListener('shopify:section:load', setHeader);



  // Desktop dropdown navigation: open on hover/focus and close cleanly on leave.
  const desktopDropdowns = qsa('.mx-nav-dropdown');
  const desktopNavQuery = window.matchMedia('(min-width: 991px)');
  const closeOtherDropdowns = current => desktopDropdowns.forEach(item => { if(item !== current) item.removeAttribute('open'); });
  desktopDropdowns.forEach(dropdown => {
    const summary = qs('summary', dropdown);
    dropdown.addEventListener('mouseenter', () => {
      if(!desktopNavQuery.matches) return;
      closeOtherDropdowns(dropdown);
      dropdown.setAttribute('open', '');
    });
    dropdown.addEventListener('mouseleave', () => {
      if(desktopNavQuery.matches) dropdown.removeAttribute('open');
    });
    dropdown.addEventListener('focusin', () => {
      if(!desktopNavQuery.matches) return;
      closeOtherDropdowns(dropdown);
      dropdown.setAttribute('open', '');
    });
    dropdown.addEventListener('focusout', e => {
      if(desktopNavQuery.matches && !dropdown.contains(e.relatedTarget)) dropdown.removeAttribute('open');
    });
    summary?.addEventListener('click', e => {
      if(desktopNavQuery.matches) e.preventDefault();
    });
  });


  // V6: the parent label itself owns the desktop dropdown hover/focus area.
  // This keeps the Heroes link clickable while still opening its child menu.
  qsa('.mx-nav-parent').forEach(parent => {
    const dropdown = qs('.mx-nav-dropdown', parent);
    if(!dropdown) return;
    parent.addEventListener('mouseenter', () => {
      if(!desktopNavQuery.matches) return;
      closeOtherDropdowns(dropdown);
      dropdown.setAttribute('open', '');
    });
    parent.addEventListener('mouseleave', () => {
      if(desktopNavQuery.matches) dropdown.removeAttribute('open');
    });
    parent.addEventListener('focusin', () => {
      if(!desktopNavQuery.matches) return;
      closeOtherDropdowns(dropdown);
      dropdown.setAttribute('open', '');
    });
    parent.addEventListener('focusout', e => {
      if(desktopNavQuery.matches && !parent.contains(e.relatedTarget)) dropdown.removeAttribute('open');
    });
  });

  const mobile = qs('[data-mobile-panel]');
  let mobileReturn = null;
  qsa('[data-mobile-open]').forEach(btn => btn.addEventListener('click', () => {
    mobileReturn = btn;
    mobile.classList.add('is-open');
    mobile.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    qs('[data-mobile-close]', mobile)?.focus();
  }));
  qsa('[data-mobile-close]').forEach(btn => btn.addEventListener('click', () => closeMobile()));
  function closeMobile(){
    mobile?.classList.remove('is-open');
    mobile?.setAttribute('aria-hidden', 'true');
    mobileReturn?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    mobileReturn?.focus();
  }

  const modal = qs('[data-newsletter-modal]');
  let modalReturn = null;
  function openModal(trigger){
    if(!modal) return;
    modalReturn = trigger || document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    qs('[role="dialog"]', modal).focus();
  }
  function closeModal(){
    if(!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    modalReturn?.focus();
  }
  qsa('[data-newsletter-open]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); openModal(el); }));
  qsa('[data-modal-close]').forEach(el => el.addEventListener('click', closeModal));
  document.addEventListener('keydown', e => {
    if(e.key === 'Escape'){ closeModal(); closeCart(); closeMobile(); }
    if(e.key === 'Tab' && modal && !modal.hidden) trapFocus(e, qs('[role="dialog"]', modal));
    if(e.key === 'Tab' && mobile?.classList.contains('is-open')) trapFocus(e, mobile);
  });
  function trapFocus(e, root){
    if(!root) return;
    const items = qsa(focusable, root).filter(el => !el.hasAttribute('hidden') && el.getAttribute('aria-hidden') !== 'true');
    if(!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }


  const newsletterForm = qs('#MythxNewsletterForm');
  newsletterForm?.addEventListener('submit', () => {
    const country = qs('[data-newsletter-country]', newsletterForm)?.value || '';
    const tags = qs('[data-newsletter-tags]', newsletterForm);
    if(tags) tags.value = `newsletter,mythx-newsletter,location:${country}`;
  });
  const cartMenu = qs('[data-cart-menu]');
  const cartToggle = qs('[data-cart-toggle]');
  const miniCart = qs('[data-mini-cart]');
  const miniCartOverlay = qs('[data-mini-cart-overlay]');
  let miniCartReturnFocus = null;
  function openCart(){
    if(!miniCart || !cartToggle) return;
    miniCartReturnFocus = document.activeElement;
    miniCart.hidden = false;
    if(miniCartOverlay) miniCartOverlay.hidden = false;
    cartMenu?.classList.add('is-open');
    document.body.classList.add('mx-mini-cart-open');
    cartToggle.setAttribute('aria-expanded','true');
    requestAnimationFrame(() => miniCart.focus());
  }
  function closeCart(restoreFocus = true){
    if(!miniCart || !cartToggle) return;
    miniCart.hidden = true;
    if(miniCartOverlay) miniCartOverlay.hidden = true;
    cartMenu?.classList.remove('is-open');
    document.body.classList.remove('mx-mini-cart-open');
    cartToggle.setAttribute('aria-expanded','false');
    if(restoreFocus && miniCartReturnFocus instanceof HTMLElement) miniCartReturnFocus.focus();
  }
  cartToggle?.addEventListener('click', e => {
    e.stopPropagation();
    miniCart?.hidden ? openCart() : closeCart();
  });
  miniCartOverlay?.addEventListener('click', () => closeCart());
  document.addEventListener('click', e => { if(cartMenu && !cartMenu.contains(e.target)) closeCart(false); });
  document.addEventListener('keydown', e => {
    if(e.key === 'Tab' && miniCart && !miniCart.hidden) trapFocus(e, miniCart);
  });

  const cartItemsEl = qs('[data-cart-items]');
  const cartSubtotalEl = qs('[data-cart-subtotal]');

  function money(cents, currency){
    return (cents/100).toLocaleString(undefined,{style:'currency',currency:currency || 'USD'});
  }
  function renderCartDrawer(cartData){
    if(!cartItemsEl) return;
    if(!cartData.item_count){
      cartItemsEl.innerHTML = '<div class="mini-cart__empty"><p>Your cart is empty.</p><a href="/collections/all">Shop merchandise</a></div>';
    } else {
      cartItemsEl.innerHTML = cartData.items.slice(0,3).map(item => `
        <article class="mini-cart__line" data-key="${item.key}">
          ${item.image ? `<img src="${item.image}" width="64" height="64" alt="${(item.product_title || '').replace(/"/g,'&quot;')}" loading="lazy">` : ''}
          <div><a href="${item.url}">${item.product_title}</a><small>${item.quantity} × ${money(item.final_price,cartData.currency)}</small></div>
          <button type="button" data-cart-remove="${item.key}" aria-label="Remove ${item.product_title}">×</button>
        </article>
      `).join('') + (cartData.item_count > 3 ? `<p class="mini-cart__more">Plus ${cartData.item_count - 3} more item(s)</p>` : '');
    }
    if(cartSubtotalEl) cartSubtotalEl.textContent = money(cartData.total_price,cartData.currency);
    qsa('[data-cart-count]').forEach(el => el.textContent = cartData.item_count);
    qsa('[data-mini-cart-label]').forEach(el => el.textContent = `${cartData.item_count} ${cartData.item_count === 1 ? 'item' : 'items'}`);
  }

  async function changeCartLine(key, quantity){
    const res = await fetch('/cart/change.js', {
      method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body: JSON.stringify({ id:key, quantity })
    });
    renderCartDrawer(await res.json());
  }

  cartItemsEl?.addEventListener('click', e => {
    const removeBtn = e.target.closest('[data-cart-remove]');
    if(removeBtn) changeCartLine(removeBtn.dataset.cartRemove, 0);
  });

  // Keep the header mini cart synchronized with custom homepage product blocks.
  window.addEventListener('cart:updated', event => {
    const cartData = event.detail;
    if(!cartData || typeof cartData.item_count !== 'number') return;
    renderCartDrawer(cartData);
    openCart();
  });


  // Delegated quick-add works on homepage, collection pages, and dynamically rendered sections.
  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-quick-add]');
    if(!form || !window.fetch) return;
    e.preventDefault();
    const btn = qs('button[type="submit"]', form);
    const defaultLabel = btn?.dataset.defaultLabel || btn?.textContent.trim() || 'Add to Cart';
    btn?.setAttribute('aria-busy', 'true');
    if(btn) btn.disabled = true;
    try{
      const res = await fetch('/cart/add.js', {
        method:'POST',
        body:new FormData(form),
        headers:{ Accept:'application/json' }
      });
      if(!res.ok) throw new Error('Cart add failed');
      const cartData = await fetch('/cart.js', { headers:{ Accept:'application/json' }}).then(r => r.json());
      renderCartDrawer(cartData);
      window.dispatchEvent(new CustomEvent('cart:updated', { detail:cartData }));
      if(btn) btn.textContent = 'Added';
      openCart();
    }catch(err){
      if(btn) btn.textContent = 'Try again';
    }finally{
      btn?.removeAttribute('aria-busy');
      window.setTimeout(() => {
        if(btn){
          btn.textContent = defaultLabel;
          btn.disabled = false;
        }
      }, 1600);
    }
  });


  qsa('[data-filter]').forEach(btn => btn.addEventListener('click', () => {
    const group = btn.closest('[data-filter-group]');
    const value = btn.dataset.filter;
    qsa('[data-filter]', group).forEach(b => b.classList.toggle('active', b === btn));
    qsa('[data-filter-item]').forEach(item => {
      const tags = (item.dataset.filterItem || '').split(',');
      item.hidden = value !== 'all' && !tags.includes(value);
    });
  }));

  const reveals = qsa('.reveal');
  const revealGroups = new Map();
  reveals.forEach(el => {
    const parent = el.parentElement;
    const list = revealGroups.get(parent) || [];
    list.push(el);
    revealGroups.set(parent, list);
  });
  revealGroups.forEach(list => list.forEach((el, i) => el.style.setProperty('--reveal-delay', Math.min(i * 110, 440) + 'ms')));
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver(entries => entries.forEach(entry => {
      if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    }), { threshold: .12 });
    reveals.forEach(el => io.observe(el));
  } else reveals.forEach(el => el.classList.add('is-visible'));

  // Subtle cinematic parallax on the hero media, desktop pointer only
  const heroMedia = qs('.mythx-hero__media');
  if(heroMedia && window.matchMedia('(pointer:fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    let raf = null;
    window.addEventListener('mousemove', e => {
      if(raf) return;
      raf = requestAnimationFrame(() => {
        const x = (e.clientX / window.innerWidth - .5) * 14;
        const y = (e.clientY / window.innerHeight - .5) * 10;
        heroMedia.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        raf = null;
      });
    }, { passive: true });
  }

  function setupCinematicInfoVisibility(modal){
    if(!modal) return;
    const dialog = qs('[role="dialog"]', modal) || modal;
    let hideTimer = null;
    const showInfo = () => {
      // V50: keep the approved cinematic title/description overlay visible.
      modal.classList.add('mx-video-info-visible');
      clearTimeout(hideTimer);
    };
    if(modal.dataset.mxInfoVisibilityReady !== 'true'){
      ['mousemove','pointermove','pointerdown','touchstart','keydown'].forEach(eventName => {
        dialog.addEventListener(eventName, showInfo, { passive: eventName !== 'keydown' });
      });
      modal.dataset.mxInfoVisibilityReady = 'true';
    }
    showInfo();
  }

  // Cinematic video popup. Delegated so buttons created after Global Episodes Library hydration
  // (including released Episodes-page cards) work without needing another manual bind.
  const openCinematicVideo = (btn) => {
    const source = btn.dataset.videoSrc || btn.dataset.videoOpen;
    const type = btn.dataset.videoType || 'mp4';
    if(!source) return;
    const wrap = document.createElement('div');
    wrap.className = 'mx-cinematic-video-modal';
    const title = btn.dataset.title || btn.getAttribute('aria-label') || 'Now Playing';
    const description = btn.dataset.description || '';
    let player = '';
    if(type === 'youtube'){
      player = `<iframe src="https://www.youtube.com/embed/${source}?autoplay=1&rel=0" title="${title}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
    }else if(type === 'vimeo'){
      player = `<iframe src="https://player.vimeo.com/video/${source}?autoplay=1" title="${title}" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
    }else{
      player = `<video controls autoplay playsinline src="${source}"></video>`;
    }
    wrap.innerHTML = `<div class="mx-cinematic-video-modal__backdrop"></div><section class="mx-cinematic-video-modal__dialog" role="dialog" aria-modal="true" tabindex="-1"><button class="mx-cinematic-video-modal__close" aria-label="Close video" type="button"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg></button>${player}<div class="mx-cinematic-video-modal__info"><p class="mx-cinematic-video-modal__eyebrow">MythX Africa</p><h2>${title}</h2>${description ? `<p>${description}</p>` : ''}</div></section>`;
    document.body.append(wrap);
    document.documentElement.classList.add('mx-video-open');
    document.body.classList.add('mx-video-open');
    const close = () => {
      qs('video', wrap)?.pause();
      const iframe = qs('iframe', wrap);
      if(iframe) iframe.src = '';
      wrap.remove();
      document.documentElement.classList.remove('mx-video-open');
      document.body.classList.remove('mx-video-open');
      btn.focus();
    };
    qs('.mx-cinematic-video-modal__backdrop', wrap).addEventListener('click', close);
    qs('.mx-cinematic-video-modal__close', wrap).addEventListener('click', close);
    setupCinematicInfoVisibility(wrap);
    wrap.addEventListener('keydown', e => { if(e.key === 'Escape') close(); });
    qs('[role="dialog"]', wrap).focus();
  };

  document.addEventListener('click', event => {
    const btn = event.target.closest('[data-video-open]');
    if(!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    openCinematicVideo(btn);
  });

  // Hero page associated episode modal (Shopify video, YouTube, or Vimeo)
  qsa('[data-mx-hero-video-open]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const id = trigger.dataset.mxHeroVideoOpen;
      const modal = qs(`[data-mx-hero-video-modal="${id}"]`);
      if(!modal) return;
      trigger.setAttribute('aria-expanded', 'true');
      modal._mxReturnFocus = trigger;
      // V50: portal Hero video modals to <body> so they sit above every theme layer,
      // matching the approved homepage cinematic popup.
      if(modal.parentNode !== document.body){
        modal._mxPortalHome = modal.parentNode;
        modal._mxPortalNext = modal.nextSibling;
        document.body.appendChild(modal);
      }
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.remove('mx-video-info-dismissed');
      setupCinematicInfoVisibility(modal);
      document.documentElement.classList.add('mx-video-open');
      document.body.classList.add('mx-video-open');
      const iframe = qs('iframe[data-src]', modal);
      if(iframe && !iframe.src) iframe.src = iframe.dataset.src;
      const video = qs('video', modal);
      video?.play().catch(() => {});
      qs('[role="dialog"]', modal)?.focus();
    });
  });
  qsa('[data-mx-hero-video-modal]').forEach(modal => {
    const closeHeroVideo = () => {
      qs('video', modal)?.pause();
      const iframe = qs('iframe', modal);
      if(iframe){ iframe.removeAttribute('src'); }
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      modal._mxReturnFocus?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('mx-video-open');
      document.body.classList.remove('mx-video-open');
      if(modal._mxPortalHome){
        const home = modal._mxPortalHome;
        const next = modal._mxPortalNext;
        if(next && next.parentNode === home) home.insertBefore(modal, next);
        else home.appendChild(modal);
        modal._mxPortalHome = null;
        modal._mxPortalNext = null;
      }
      modal._mxReturnFocus?.focus();
    };
    qsa('[data-mx-hero-video-close]', modal).forEach(el => el.addEventListener('click', closeHeroVideo));

    modal.addEventListener('keydown', e => {
      if(e.key === 'Escape') closeHeroVideo();
      if(e.key === 'Tab' && !modal.hidden) trapFocus(e, qs('[role="dialog"]', modal));
    });
  });

  // Explore Africa: region pins / sidebar select a country panel
  const explore = qs('[data-explore-map]');
  if(explore){
    const setRegion = (region) => {
      qsa('[data-region-trigger]', explore).forEach(b => b.classList.toggle('is-active', b.dataset.regionTrigger === region));
      qsa('[data-region-panel]', explore).forEach(p => { p.hidden = p.dataset.regionPanel !== region; });
    };
    qsa('[data-region-trigger]', explore).forEach(btn => btn.addEventListener('click', () => setRegion(btn.dataset.regionTrigger)));
    qsa('[data-panel-close]', explore).forEach(btn => btn.addEventListener('click', () => {
      qsa('[data-region-panel]', explore).forEach(p => p.hidden = true);
      qsa('[data-region-trigger]', explore).forEach(b => b.classList.remove('is-active'));
    }));
  }

  // Simple prev/next carousels (heroes, mythology, etc.)
  qsa('[data-carousel]').forEach(carousel => {
    const items = qsa('[data-carousel-item]', carousel);
    if(!items.length) return;
    let index = 0;
    const show = i => {
      index = (i + items.length) % items.length;
      items.forEach((el, n) => el.hidden = n !== index);
      qsa('[data-carousel-dot]', carousel).forEach((d, n) => d.classList.toggle('is-active', n === index));
    };
    qs('[data-carousel-prev]', carousel)?.addEventListener('click', () => show(index - 1));
    qs('[data-carousel-next]', carousel)?.addEventListener('click', () => show(index + 1));
    qsa('[data-carousel-dot]', carousel).forEach((d, n) => d.addEventListener('click', () => show(n)));
    show(0);
  });


})();
